import React from 'react';

export interface Props {
    page: number;
    totalPages: number;
    handlePagination: (page: number) => void;
    disabled?: boolean;
}

export const Pagination: React.FC<Props> = ({ page, totalPages, handlePagination, disabled = false }) => {
    if (totalPages <= 1) {
        return null;
    }
    
    return (
        <div className="pagination">
            <div className="paginationWrapper">
                {page !== 1 && (
                    <button
                        onClick={() => handlePagination(page - 1)}
                        type="button"
                        className="pageItem sides"
                        disabled={disabled}
                    >
                        &lt;
                    </button>
                )}
                <button
                    onClick={() => handlePagination(1)}
                    type="button"
                    className={'pageItem ' + (page === 1 ? 'active' : '')}
                    disabled={disabled}
                >
                    {1}
                </button>
                {page > 3 && <div className="separator">...</div>}
                {page === totalPages && totalPages > 3 && (
                    <button
                        onClick={() => handlePagination(page - 2)}
                        type="button"
                        className="pageItem"
                        disabled={disabled}
                    >
                        {page - 2}
                    </button>
                )}
                {page > 2 && (
                    <button
                        onClick={() => handlePagination(page - 1)}
                        type="button"
                        className="pageItem"
                        disabled={disabled}
                    >
                        {page - 1}
                    </button>
                )}
                {page !== 1 && page !== totalPages && (
                    <button
                        onClick={() => handlePagination(page)}
                        type="button"
                        className="pageItem active"
                        disabled={disabled}
                    >
                        {page}
                    </button>
                )}
                {page < totalPages - 1 && (
                    <button
                        onClick={() => handlePagination(page + 1)}
                        type="button"
                        className="pageItem"
                        disabled={disabled}
                    >
                        {page + 1}
                    </button>
                )}
                {page === 1 && totalPages > 3 && (
                    <button
                        onClick={() => handlePagination(page + 2)}
                        type="button"
                        className="pageItem"
                        disabled={disabled}
                    >
                        {page + 2}
                    </button>
                )}
                {page < totalPages - 2 && <div className="separator">...</div>}
                <button
                    onClick={() => handlePagination(totalPages)}
                    type="button"
                    className={'pageItem ' + (page === totalPages ? 'active' : '')}
                    disabled={disabled}
                >
                    {totalPages}
                </button>
                {page !== totalPages && (
                    <button
                        onClick={() => handlePagination(page + 1)}
                        type="button"
                        className="pageItem sides"
                        disabled={disabled}
                    >
                        &gt;
                    </button>
                )}
            </div>
        </div>
    );
};
